import React, { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Klanten from './pages/Klanten';
import Bonnen from './pages/Bonnen';
import Betalingen from './pages/Betalingen';
import Kosten from './pages/Kosten';
import Herhaalfacturen from './pages/Herhaalfacturen';
import VasteActiva from './pages/VasteActiva';
import Efacturatie from './pages/Efacturatie';
import SmsHerinneringen from './pages/SmsHerinneringen';
import AanDeSlag from './pages/AanDeSlag';
import Integraties from './pages/Integraties';
import Debiteuren from './pages/Debiteuren';
import Boekhouding from './pages/Boekhouding';
import Herinneringen from './pages/Herinneringen';
import Grootboek from './pages/Grootboek';
import Balans from './pages/Balans';
import Bankimport from './pages/Bankimport';
import AutoHandel from './pages/AutoHandel';
import Advertentiemaker from './pages/Advertentiemaker';
import OnderdelenVoorraad from './pages/OnderdelenVoorraad';
import Sloopautos from './pages/Sloopautos';
import Verkoophistorie from './pages/Verkoophistorie';
import OnderdelenBinnenkort from './pages/OnderdelenBinnenkort';
import Showroom from './pages/Showroom';
import ShowroomPublic from './pages/ShowroomPublic';
import InfoPagina from './pages/InfoPagina';
import Planning from './pages/Planning';
import ApkOnderhoud from './pages/ApkOnderhoud';
import Bandenhotel from './pages/Bandenhotel';
import OnlineAfspraken from './pages/OnlineAfspraken';
import BookingPage from './pages/BookingPage';
import AkkoordPage from './pages/AkkoordPage';
import BetaalPage from './pages/BetaalPage';
import KlantPortaalPage from './pages/KlantPortaalPage';
import LandingPage from './pages/LandingPage';
import LegalPage from './pages/LegalPage';
import DeviceGuard from './components/DeviceGuard';
import Meldingen from './pages/Meldingen';
import Onderdelen from './pages/Onderdelen';
import Prijsvergelijk from './pages/Prijsvergelijk';
import Rapportage from './pages/Rapportage';
import Documenten from './pages/Documenten';
import Werkkaart from './pages/Werkkaart';
import Diagnose from './pages/Diagnose';
import Zoeken from './pages/Zoeken';
import Gegevens from './pages/Gegevens';
import Instellingen from './pages/Instellingen';
import AiKeyBanner from './components/AiKeyBanner';
import BonLayout from './pages/BonLayout';
import Verrekenen from './pages/Verrekenen';
import LoginPage from './pages/LoginPage';
import PricingPage from './pages/PricingPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import AdminOrders from './pages/AdminOrders';
import Leveranciers from './pages/Leveranciers';
import Inkooporders from './pages/Inkooporders';
import Waardebepaling from './pages/Waardebepaling';
import OnderdelenCatalogus from './pages/OnderdelenCatalogus';
import FoutcodeUitleg from './pages/FoutcodeUitleg';
import OfferteAssistent from './pages/OfferteAssistent';
import Garantieclaims from './pages/Garantieclaims';
import UpgradeGate from './components/UpgradeGate';
import { Toaster } from './components/ui/sonner';
import { Menu } from 'lucide-react';
import { SyncStatusBadge } from './components/SyncStatusBadge';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import { DataProvider, useData } from './context/DataContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider, useT } from './context/LanguageContext';

const pageMeta = {
  dashboard: { title: 'Dashboard', hint: 'Snelle acties: klanten, bonnen, planning en RDW direct vanaf het dashboard' },
  zoeken: { title: 'Zoeken', hint: 'Zoek door klanten, bonnen, kentekens en documenten' },
  werkkaart: { title: 'Werkkaart', hint: 'Werkkaart: nieuwe bon bovenaan, open klant, nieuwe planning, open PDF' },
  diagnose: { title: 'AI Diagnose', hint: 'Upload een diagnoserapport (PDF) — AI maakt automatisch klant, voertuig en werkbon met uitleg' },
  klanten: { title: 'Klanten', hint: 'Sneltoetsen: F1 nieuwe klant | F2 bewerken | F3 map | Del verwijderen | F4 auto' },
  bonnen: { title: 'Bonnen', hint: 'Sneltoetsen: F1 nieuwe bon | F2 openen | F3 map | Del verwijderen' },
  betalingen: { title: 'Betalingen', hint: 'Acties: betaling toevoegen, refund, betaling verwijderen, document openen' },
  kosten: { title: 'Kosten / Inkoopfacturen', hint: 'Registreer uitgaven en inkoopfacturen voor je boekhouding en BTW-aangifte' },
  herhaalfacturen: { title: 'Herhaalfacturen', hint: 'Periodiek automatisch facturen genereren en (optioneel) mailen' },
  vasteactiva: { title: 'Vaste activa & afschrijvingen', hint: 'Investeringen lineair afschrijven en de boekwaarde volgen' },
  debiteuren: { title: 'Debiteurenbeheer', hint: 'Openstaande facturen, ouderdomsanalyse (aging) en betalingsherinneringen versturen' },
  boekhouding: { title: 'Boekhouding — BTW & Winst', hint: 'BTW-aangifte overzicht en winst- & verliesrekening per kwartaal of jaar' },
  herinneringen: { title: 'Automatische betalingsherinneringen', hint: 'Stel automatische herinneringen in en bekijk verstuurde herinneringen' },
  grootboek: { title: 'Grootboek', hint: 'Dubbel boekhouden — saldi per grootboekrekening, automatisch geboekt' },
  balans: { title: 'Balans', hint: 'Activa en passiva op basis van je grootboek' },
  bankimport: { title: 'Bankimport', hint: 'Importeer een MT940- of CAMT.053-afschrift en letter automatisch af tegen facturen en kosten' },
  autohandel: { title: 'Auto handel', hint: 'Tip: gebruik rechtermuisklik op de lijst voor snelle auto-acties' },
  planning: { title: 'Planning', hint: 'Acties: nieuwe afspraak | bewerken | verwijderen | bevestiging | herinnering | vandaag' },
  onlineafspraken: { title: 'Online afspraken', hint: 'Deelbare boekingslink, diensten + duur, openingstijden en slot-instellingen' },
  meldingen: { title: 'Meldingen', hint: 'Meldingen: open relevante klant, planning of document direct vanuit de lijst' },
  onderdelen: { title: 'Onderdelen', hint: 'Onderdelen: import uit bonnen, bewerk voorraad en filter direct in dit scherm' },
  prijsvergelijk: { title: 'Prijsvergelijk', hint: 'Vergelijk onderdeelprijzen in 4 webshops op basis van voertuig + onderdeel' },
  rapportage: { title: 'Rapportage', hint: 'Rapportage: kies periode, filters en exporteer daarna de uitkomst' },
  verrekenen: { title: 'Verrekenen', hint: 'Winstaandeel per teamlid en voorgeschoten kosten verrekenen' },
  documenten: { title: 'Documenten', hint: 'Documenten: upload PDF/foto, sync naar cloud bij actieve licentie' },
  bonlayout: { title: 'Bon layout', hint: 'Bon layout: pas layout aan en bekijk het resultaat direct naast elkaar' },
  gegevens: { title: 'Gegevens', hint: 'Gegevens: garagegegevens en factuurinformatie centraal beheren' },
  instellingen: { title: 'Instellingen', hint: 'Instellingen: licentie, cloud, team, SMTP en back-up op 1 plek' }
};

function Shell() {
  const [activePage, setActivePage] = useState('dashboard');
  const [mobileOpen, setMobileOpen] = useState(false);
  const { loading, error, stats } = useData();
  const { user, logout } = useAuth();

  const licensed = ['PRO', 'ENTERPRISE', 'LIFETIME'].includes(stats?.plan);
  const BOEKHOUDEN_KEYS = ['debiteuren', 'kosten', 'herhaalfacturen', 'vasteactiva', 'efacturatie', 'herinneringen', 'smsherinneringen', 'boekhouding', 'grootboek', 'balans', 'bankimport'];

  const renderPage = () => {
    if (loading) return <div className="cs-empty">Bezig met laden van MonteurCentraal data...</div>;
    if (error) return <div className="cs-empty" style={{ color: 'var(--cs-red)' }}>Fout bij laden: {error}</div>;
    // License-gating: Boekhouden + Online afspraken zijn alleen voor PRO/ENTERPRISE/LIFETIME
    if (!licensed && BOEKHOUDEN_KEYS.includes(activePage)) return <UpgradeGate feature="boekhouden" onNavigate={setActivePage} />;
    if (!licensed && activePage === 'onlineafspraken') return <UpgradeGate feature="onlineafspraken" onNavigate={setActivePage} />;
    if (!licensed && activePage === 'diagnose') return <UpgradeGate feature="diagnose" onNavigate={setActivePage} />;
    if (!licensed && activePage === 'advertentie') return <UpgradeGate feature="advertentie" onNavigate={setActivePage} />;
    if (!licensed && activePage.startsWith('oh-')) return <UpgradeGate feature="onderdelenhandel" onNavigate={setActivePage} />;
    if (!licensed && activePage === 'showroom') return <UpgradeGate feature="showroom" onNavigate={setActivePage} />;
    switch (activePage) {
      case 'dashboard': return <Dashboard onNavigate={setActivePage} />;
      case 'zoeken': return <Zoeken />;
      case 'werkkaart': return <Werkkaart onNavigate={setActivePage} />;
      case 'diagnose': return <Diagnose onNavigate={setActivePage} />;
      case 'klanten': return <Klanten onNavigate={setActivePage} />;
      case 'bonnen': return <Bonnen />;
      case 'betalingen': return <Betalingen />;
      case 'kosten': return <Kosten />;
      case 'herhaalfacturen': return <Herhaalfacturen />;
      case 'vasteactiva': return <VasteActiva />;
      case 'efacturatie': return <Efacturatie />;
      case 'smsherinneringen': return <SmsHerinneringen />;
      case 'aandeslag': return <AanDeSlag onNavigate={setActivePage} />;
      case 'integraties': return <Integraties onNavigate={setActivePage} />;
      case 'debiteuren': return <Debiteuren />;
      case 'boekhouding': return <Boekhouding />;
      case 'herinneringen': return <Herinneringen />;
      case 'grootboek': return <Grootboek />;
      case 'balans': return <Balans />;
      case 'bankimport': return <Bankimport />;
      case 'autohandel': return <AutoHandel />;
      case 'advertentie': return <Advertentiemaker />;
      case 'oh-voorraad': return <OnderdelenVoorraad />;
      case 'oh-gebruikt': return <OnderdelenVoorraad conditieFilter="Gebruikt" titel="Gebruikte onderdelen" />;
      case 'oh-sloop': return <Sloopautos onNavigate={setActivePage} />;
      case 'oh-historie': return <Verkoophistorie />;
      case 'showroom': return <Showroom />;
      case 'leveranciers': return <Leveranciers />;
      case 'inkooporders': return <Inkooporders />;
      case 'garantieclaims': return <Garantieclaims />;
      case 'info': return <InfoPagina />;
      case 'oh-nieuw': return <OnderdelenCatalogus />;
      case 'oh-advertenties': return <OnderdelenVoorraad titel="Onderdeel-advertenties (AI)" />;
      case 'oh-waardebepaling': return <Waardebepaling />;
      case 'ai-foutcode': return <FoutcodeUitleg />;
      case 'ai-offerte': return <OfferteAssistent />;
      case 'planning': return <Planning />;
      case 'apk': return <ApkOnderhoud onNavigate={setActivePage} />;
      case 'bandenhotel': return <Bandenhotel onNavigate={setActivePage} />;
      case 'onlineafspraken': return <OnlineAfspraken />;
      case 'meldingen': return <Meldingen onNavigate={setActivePage} />;
      case 'onderdelen': return <Onderdelen />;
      case 'prijsvergelijk': return <Prijsvergelijk />;
      case 'rapportage': return <Rapportage />;
      case 'verrekenen': return <Verrekenen />;
      case 'documenten': return <Documenten />;
      case 'bonlayout': return <BonLayout />;
      case 'gegevens': return <Gegevens />;
      case 'instellingen': return <Instellingen />;
      default: return <Dashboard onNavigate={setActivePage} />;
    }
  };

  const meta = pageMeta[activePage] || pageMeta.dashboard;

  return (
    <div className="app-shell">
      <DeviceGuard />
      <div className="mobile-topbar">
        <button className="mobile-hamburger" onClick={() => setMobileOpen(true)} data-testid="mobile-menu-open" aria-label="Menu"><Menu size={24} /></button>
        <span className="mobile-logo">MonteurCentraal</span>
        <span style={{ width: 44 }} />
      </div>
      <div className={`cs-sidebar-overlay ${mobileOpen ? 'mobile-open' : ''}`} onClick={() => setMobileOpen(false)} data-testid="mobile-menu-overlay" />
      <Sidebar activePage={activePage} onNavigate={setActivePage} user={user} onLogout={logout} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <main className="app-host">
        <div className="page-fade" key={activePage}>
          <AiKeyBanner activePage={activePage} onNavigate={setActivePage} />
          {renderPage()}
        </div>
      </main>
    </div>
  );
}

function AuthGate() {
  const { user, loading, token } = useAuth();
  const { applyAccountLang } = useT();
  // Pas de taalvoorkeur van het ingelogde account toe (volgt de gebruiker bij inloggen)
  React.useEffect(() => {
    if (user && user.lang) applyAccountLang(user.lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user && user.lang]);
  // Public routes (no auth required)
  const path = window.location.pathname;
  if (path === '/pricing') return <PricingPage />;
  if (path === '/checkout-success') return <CheckoutSuccessPage />;
  if (path === '/admin/bestellingen') return <AdminOrders />;
  if (path === '/privacy') return <LegalPage doc="privacy" />;
  if (path === '/voorwaarden') return <LegalPage doc="voorwaarden" />;
  if (path.startsWith('/afspraak/')) {
    const garageId = decodeURIComponent(path.split('/afspraak/')[1] || '').replace(/\/+$/, '');
    return <BookingPage garageId={garageId} />;
  }
  if (path.startsWith('/showroom/')) {
    const slug = decodeURIComponent(path.split('/showroom/')[1] || '').replace(/\/+$/, '');
    return <ShowroomPublic slug={slug} />;
  }
  if (path.startsWith('/akkoord/')) {
    const token = decodeURIComponent(path.split('/akkoord/')[1] || '').replace(/\/+$/, '');
    return <AkkoordPage token={token} />;
  }
  if (path.startsWith('/betalen/')) {
    const token = decodeURIComponent(path.split('/betalen/')[1] || '').replace(/\/+$/, '');
    return <BetaalPage token={token} />;
  }
  if (path.startsWith('/portaal/')) {
    const garageId = decodeURIComponent(path.split('/portaal/')[1] || '').replace(/\/+$/, '');
    return <KlantPortaalPage garageId={garageId} />;
  }
  // Marketing landingspagina op de hoofd-URL voor niet-ingelogde bezoekers
  const params = new URLSearchParams(window.location.search);
  const authIntent = params.get('login') === '1' || params.get('register') === '1' || params.get('token') || params.get('reset') === '1';
  if (!token && path === '/' && !authIntent) return <LandingPage />;
  if (loading) return <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f6fb', color: '#64748b' }}>Laden...</div>;
  if (!token || !user) return <LoginPage initialMode={params.get('register') === '1' ? 'register' : 'login'} />;
  return <DataProvider><Shell /></DataProvider>;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AuthGate />
        <Toaster position="bottom-right" />
        <SyncStatusBadge />
        <PWAInstallPrompt />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
